import { messages as validation } from "vee-validate/dist/locale/pt_PT.json";
import { countryList } from "@/locales/properNouns";
import messages from "./json/pt.json";

export default {
  pl: {
    word: "{n} {word}",
  },
  validation: {
    ...validation,
    credit_card: "O campo {_field_} deve ser um número de cartão de crédito válido",
    required_select: validation.required,
  },
  notificationsText: {
    liked: "{screenName} curtiu seu {type}",
    followed: "{screenName} seguiu você",
    subscribed: "{screenName} assinou você por {price}",
    upgradeSubscription: "{screenName} atualizou a assinatura para você. Agora o nível de assinatura é {price}",
    soldPost: "{screenName} comprou sua postagem por {price}",
    soldAttachment: "{screenName} comprou seu anexo por {price}",
    soldEvent: "{screenName} reservou seu evento {date} por {price}",
    eventPublished: "Próximo evento de {screenName}!",
    eventStarted: "O evento começou",
    eventCancelled: "{screenName} cancelou o evento",
    sendReview: "{screenName} deixou um comentário: {review}",
    sendMentionedReview: "{screenName} respondeu você: {review}",
    appointmentRequested: "{screenName} solicitou {appointmentType} com você",
    appointmentApproved: "{screenName} aceitou {appointmentType} com você",
    appointmentRejected: "{screenName} rejeitou {appointmentType} com você",
    appointmentCancelled: "{screenName} cancelou {appointmentType} com você",
    appointmentReminder: "Faltam {timeLeft} para o compromisso com {screenName}",
    appointmentNoResponse:
      "{screenName} não respondeu à sua solicitação de {appointmentType}. Dinheiro devolvido à sua carteira",
    fundraisingFinished: "{goal} finalizado!",
    fundraisingStarted: "{screenName} definiu um {goal}",
    fundraisingDonationCreated: "{screenName} doou {amount} para {goal}",
  },
  ...countryList,
  ...messages,
};
